import ScrollTrigger from "gsap/ScrollTrigger";

class Quotes {
  constructor($el) {
    this.$el = $el;
    this.$slider = $el.find('[data-quotes="slider"]');
    this.$index = $el.find('[data-quotes="index"]');
    this.init();
  }

  init = () => {
    import("slick-carousel").then(() => {
      this.slick = this.$slider.slick({
        infinite: true,
        speed: 500,
        dots: false,
        fade: false,
        slidesToShow: 1,
        arrows: false,
        vertical: false, 
        autoplay: true ,
        autoplaySpeed: 5000,
        adaptiveHeight: false,
        responsive: [
          {
						breakpoint: 992,
						settings: {
							vertical: false,
						},
					},
        ]
      });

      this.slick.on('afterChange', this.onAfterChangeHandler);

      this.$index.on('click', this.indexClickHandler);

      ScrollTrigger.refresh();
    })
  }

  onAfterChangeHandler = () => {
    let { slick } = this.slick[0];
    let index = slick.currentSlide;
    this.$index.removeClass('active');
    this.$index.eq(index).addClass('active');
  };

  indexClickHandler = (e) => {
    let index = $(e.currentTarget).data('index');

    this.slick.slick('slickGoTo', index);
  };
}

export default Quotes;